<script>
  import moment from 'moment'

  export default {
    components: {},
    nome: 'resultado-importacao-csv-grvs',
    props: {
      relatorio: {
        type: Object,
        required: true
      }
    },
    data () {
      return {
        data: {
          quantidadeEnviada: 0,
          grvsInvalidas: [],
          grvsNaoEncontradas: []
        },
        isLoaded: false,
        semResultado: false
      }
    },
    computed: {
      total () {
        return this.relatorio.quantidadeEnviada
      },
      quantidadeGrvsInvalidas () {
        return this.relatorio.grvsInvalidas.length
      },
      quantidadeGrvsNaoEncontradas () {
        return this.relatorio.grvsNaoEncontradas.length
      },
      quantidadeGrvsEncontradas () {
        return this.total - (this.quantidadeGrvsInvalidas + this.quantidadeGrvsNaoEncontradas)
      },
      porcentagemInvalidas () {
        return this.calculaPorcentagem(this.quantidadeGrvsInvalidas, this.total)
      },
      porcentagemNaoEncontradas () {
        return this.calculaPorcentagem(this.quantidadeGrvsNaoEncontradas, this.total)
      },
      porcentagemEfetividade () {
        const valor = this.calculaPorcentagem(this.quantidadeGrvsEncontradas, this.total)
        return {
          valor,
          class: parseInt(valor) === 100 ? 'text-success' : 'text-danger'
        }
      },
      grvsInvalidasFormatado () {
        return this.relatorio.grvsInvalidas.join('\n')
      },
      grvsNaoEncontradasFormatado () {
        return this.relatorio.grvsNaoEncontradas.join('\n')
      }
    },
    mounted () {
      this.isLoaded = true
      console.log(this.relatorio)
    },
    filters: {
      formatarData (date) {
        return moment(date).format('DD/MM/YYYY LTS')
      }
    },
    methods: {
      calculaPorcentagem (valor, total) {
        if (total < 1) return 0
        return ((valor / total) * 100).toFixed(2)
      }
    }
  }
</script>

<template>
  <transition name="slide">
    <div class="content-transition" v-if="isLoaded">
      <div class="bg-light lter b-b wrapper-md">
        <div class="row">
          <div class="col-sm-6"><h1 class="m-n font-thin h3">Resultado da importação</h1></div>
        </div>
      </div>
      <div class="wrapper-md">
        <div class="panel">
          <div class="panel-body">
            <div class="resultado-estatísticas-importacao-csv m-b-lg" v-if="!semResultado">
              <div>Total enviado: <span>{{total}}</span></div>
              <div>Grvs inválidas: <span>{{quantidadeGrvsInvalidas}} ({{porcentagemInvalidas}}%)</span></div>
              <div>Grvs não encontradas: <span>{{quantidadeGrvsNaoEncontradas}} ({{porcentagemNaoEncontradas}}%)</span></div>
              <div>Efetividade: <span :class="porcentagemEfetividade.class">{{porcentagemEfetividade.valor}}%</span></div>
            </div>
            <div>
              <div class="text-dark resultado-success m-t-xl" v-if="semResultado">
                <i class="fa fa-warning fa-5x"></i>
                <span>Leilão não foi gerado via importação csv de Grvs!</span>
              </div>
              <div class="text-success resultado-success m-t-xl" v-else-if="parseInt(porcentagemEfetividade.valor) === 100">
                <i class="fa fa-check-circle fa-5x"></i>
                <span>Todos as Grvs foram encontradas!</span>
              </div>
              <div class="resultado-estatísticas-importacao-csv" v-else>
                <div>
                  <label for="txt-placas-invalidas">Grvs inválidas:</label>
                  <textarea id="txt-placas-invalidas" class="form-control" style="white-space: pre-wrap" cols="30" rows="10" readonly v-model="grvsInvalidasFormatado"></textarea>
                </div>
                <div>
                  <label for="txt-placas-nao-encontradas">Grvs não encontradas: <i class="fa fa-question-circle" style="cursor: pointer" title="A placa não foi encontrada no sistema, ou não está com status 'no pátio'"></i> </label>
                  <textarea id="txt-placas-nao-encontradas" class="form-control" style="white-space: pre-wrap" cols="30" rows="10" readonly v-model="grvsNaoEncontradasFormatado"></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style scoped>
  .resultado-estatísticas-importacao-csv {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
  }
  .resultado-estatísticas-importacao-csv span {
    font-weight: bold;
  }
  .resultado-success {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
  }
  textarea {
    resize: none;
  }
</style>



// WEBPACK FOOTER //
// ResultadoImportacaoCsvGrv.vue?106efa3c